<template>
    <div class="modal-background"></div>
    <div class="modal-container">
        <img style="margin-top: 10%; width: 80%;"
            src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/a1ec4083-18a0-4e6f-a5d7-c9cd45eedac0.svg"
            class="icon" alt="">

        <p style="font-weight: bold;">Sua licença acabou</p>
        <p style="margin-top: 5px;font-size: 12px">Vamos iniciar sua trilha de Re-Onboarding?</p>

        <v-btn @click="entrelacos" color="#660099" style="margin-top: 20px;" width="90%">Iniciar Onboarding</v-btn>
    </div>
</template>

<script setup>
import { defineEmits, onMounted } from 'vue';
import { useFelixBagAuxStore } from '../../../../store';

const felixBagAuxStore = useFelixBagAuxStore();

onMounted(() => {
  felixBagAuxStore.pauseVideo()
});

const emit = defineEmits(["close-modal", "modal-entrelacos"])

function entrelacos() {
    emit("modal-entrelacos")
    emit('close-modal')
}

</script>

<style scoped>
.modal-background {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 4;
    background-color: black;
    opacity: 0.4;
}

.modal-container {
    position: absolute;
    width: 90%;
    height: 60%;
    border-radius: 12px;
    background-color: #fff;
    top: 15%;
    left: 5%;
    z-index: 4;
}

.close {
    position: absolute !important;
    left: 75%;
    top: 5%;
}

.close img {
    width: 20px;
}
</style>